import React from 'react';
import { Link } from 'react-router-dom';

const IMG_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5000').replace('/api', '');

function getSellerBadge(providerJoined, providerRating, providerTotalReviews, providerVerified) {
  const rating = parseFloat(providerRating) || 0;
  const reviews = parseInt(providerTotalReviews) || 0;
  const joined = providerJoined ? new Date(providerJoined) : null;
  const months = joined ? Math.floor((Date.now() - joined.getTime()) / (1000 * 60 * 60 * 24 * 30)) : 0;
  if (rating >= 4.5 && reviews >= 20 && months >= 6) return { label: 'Top Rated', color: 'bg-yellow-400 text-yellow-900', icon: '🏆' };
  if (rating >= 4.0 && reviews >= 10 && months >= 3) return { label: 'Trusted', color: 'bg-green-500 text-white', icon: '✅' };
  if (providerVerified) return { label: 'Verified', color: 'bg-blue-500 text-white', icon: '🔷' };
  if (months >= 1) return { label: 'Active', color: 'bg-gray-500 text-white', icon: '🟢' };
  return { label: 'Just Joined', color: 'bg-purple-500 text-white', icon: '👤' };
}

const ServiceCard = ({ service }) => {
  const images = typeof service.images === 'string' ? JSON.parse(service.images || '[]') : (service.images || []);
  const imageUrl = images.length > 0 ? `${IMG_BASE}${images[0]}` : null;
  const badge = getSellerBadge(service.provider_joined, service.provider_rating, service.provider_total_reviews, service.provider_verified);

  return (
    <Link to={`/services/${service.id}`} className="group block bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-0.5 border border-gray-100">
      <div className="relative h-44 bg-gray-100 overflow-hidden">
        {imageUrl ? (
          <img src={imageUrl} alt={service.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-300">
            <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 13.255A23.193 23.193 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
          </div>
        )}
        <div className="absolute top-2 left-2">
          <span className={`inline-flex items-center gap-1 text-[10px] px-2 py-0.5 rounded font-semibold backdrop-blur-sm ${badge.color}`}>
            {badge.icon} {badge.label}
          </span>
        </div>
        {service.is_promoted && (
          <span className="absolute top-2 right-2 bg-yellow-400 text-yellow-900 text-[10px] font-bold px-2 py-0.5 rounded shadow-sm">⭐ PROMOTED</span>
        )}
      </div>
      <div className="p-3.5">
        <div className="flex items-center justify-between mb-1.5">
          <span className="text-xs font-semibold text-primary-600 bg-primary-50 px-2 py-0.5 rounded">{service.category_name}</span>
          {service.provider_rating > 0 && (
            <span className="flex items-center text-xs text-yellow-500 font-medium">★ {Number(service.provider_rating).toFixed(1)}</span>
          )}
        </div>
        <h3 className="font-semibold text-gray-900 text-sm mb-1 truncate group-hover:text-primary-600 transition-colors">{service.title}</h3>
        <p className="text-gray-500 text-xs line-clamp-2 mb-2.5">{service.description}</p>
        <div className="flex items-center justify-between">
          <span className="text-primary-600 font-bold text-sm">
            {service.price && Number(service.price) > 0 ? (
              <>
                {service.price_type !== 'negotiable' && <span className="text-[10px] font-normal text-gray-400">From </span>}
                {Number(service.price).toLocaleString()} RWF
                {service.price_type === 'negotiable' && <span className="text-[10px] font-normal text-gray-400 ml-1">(Nego)</span>}
                {service.price_type === 'hourly' && <span className="text-[10px] font-normal text-gray-400 ml-0.5">/hr</span>}
              </>
            ) : (
              <span className="text-gray-500 font-medium">Contact for price</span>
            )}
          </span>
          {service.location && (
            <span className="text-[11px] text-gray-400 flex items-center gap-0.5">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /></svg>
              {service.location}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ServiceCard;
